<template>
    <div class="row">
        <div class="col-12">
            <div class="card bg-warning-subtle mb-3">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body text-elev-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                 class="card-icon lucide lucide-circle-alert">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="12" x2="12" y1="8" y2="12"/>
                                <line x1="12" x2="12.01" y1="16" y2="16"/>
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <h5 class="card-title text-xs">{{ $t('Fødselsnummer mangler') }}</h5>
                        </div>
                        <div class="card-body pt-1">
                            {{ $t('Vennligst angi ditt fulle fødselsnummer. Skolen behøver dette bl.a. for å melde inn opplæring til Statens vegvesen og noen funksjoner her i elevappen.') }}
                            <div class="hr-wrapper">
                                <hr>
                            </div>
                            <div class="d-flex gap-4">
                                <a class="btn btn-primary btn-block" href="/profile">{{ $t('Profil') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
